export const PLANNING_TABLE_COLUMNS = Object.freeze([
  {header: "№пп", accessorKey: "number", size: 45},
  {header: "TP №", accessorKey: "transportPoolNumber", size: 130, isSortable: true},
  {header: "Start point", accessorKey: "startPoint", size: 120, isSortable: true},
  {header: "End point", accessorKey: "endPoint", size: 120, isSortable: true},
  {header: "SP №", accessorKey: "stockPoolNumber", size: 130, isSortable: true},
  {header: "FD", accessorKey: "finalDestination", size: 80, isSortable: true},
  {header: "Request №", accessorKey: "requestNumber", size: 130, isSortable: true},
  {header: "CO Manager", accessorKey: "managerCo", size: 130, isSortable: true},
  {header: "Client date", accessorKey: "clientDate", size: 110, isSortable: true, sortingFn: "sortDate"},
  {header: "Bring to", accessorKey: "bringTo", size: 110, isSortable: true, sortingFn: "sortDate"},
  {header: "Factory", accessorKey: "factory", size: 120, isSortable: true},
  {header: "Packing List №", accessorKey: "packingListNumber", size: 140, isSortable: true},
  {header: "Notes", accessorKey: "note", size: 180, alignStart: true},
  {header: "Delivery country", accessorKey: "deliveryCountry", size: 130, isSortable: true},
  {header: "Logist", accessorKey: "logist", size: 120, isSortable: true},
  {header: "FEA Manager", accessorKey: "managerFea", size: 130, isSortable: true},
]);

export const REQUEST_TABLE_COLUMNS = Object.freeze([
  {header: "№пп", accessorKey: "number", size: 45},
  {header: "SP №", accessorKey: "stockPoolNumber", size: 130, isSortable: true},
  {header: "Request №", accessorKey: "requestNumber", size: 130, isSortable: true},
  {header: "CO Manager", accessorKey: "managerCo", size: 130, isSortable: true},
  {header: "Client date", accessorKey: "clientDate", size: 110, isSortable: true, sortingFn: "sortDate"},
  {header: "Bring to", accessorKey: "bringTo", size: 110, isSortable: true, sortingFn: "sortDate"},
  {header: "Factory", accessorKey: "factory", size: 120, isSortable: true},
  {header: "Packing List №", accessorKey: "packingListNumber", size: 140, isSortable: true},
  {header: "Notes", accessorKey: "note", size: 180, alignStart: true},
  {header: "Delivery country", accessorKey: "deliveryCountry", size: 130, isSortable: true},
  {header: "Logist", accessorKey: "logist", size: 120, isSortable: true},
  {header: "FEA Manager", accessorKey: "managerFea", size: 130, isSortable: true},
]);

export const PLANNING_DETAILS_REQUEST_COLUMNS = Object.freeze([
  {header: "№пп", accessorKey: "number", size: 45},
  {header: "Request №", accessorKey: "requestNumber", size: 130, isSortable: true},
  {header: "CO Manager", accessorKey: "managerCo", size: 130, isSortable: true},
  {header: "Client date", accessorKey: "clientDate", size: 110, isSortable: true, sortingFn: "sortDate"},
  {header: "Bring to", accessorKey: "bringTo", size: 110, isSortable: true, sortingFn: "sortDate"},
  {header: "Factory", accessorKey: "factory", size: 120, isSortable: true},
  {header: "Notes", accessorKey: "note", size: 180, alignStart: true},
]);

export const PLANNING_DETAILS_DOCUMENT_COLUMNS = Object.freeze([
  {header: "№пп", accessorKey: "number", size: 45},
  {header: "Document type", accessorKey: "documentType", size: 120, isSortable: true},
  {header: "Document date", accessorKey: "documentDate", size: 110, isSortable: true, sortingFn: "sortDate"},
  {header: "Document №", accessorKey: "documentNumber", size: 140, isSortable: true},
  {header: "Height (m)", accessorKey: "height", size: 90},
  {header: "Loading date", accessorKey: "loadingDate", size: 110, isSortable: true, sortingFn: "sortDate"},
  {header: "Note", accessorKey: "note", size: 160, alignStart: true},
  {header: "Who and when added", accessorKey: "addedBy", size: 170},
]);

export const PLANNING_DETAILS_DIMENSION_COLUMNS = Object.freeze([
  {header: "№пп", accessorKey: "number", size: 45},
  {header: "Location", accessorKey: "location", size: 110, isSortable: true},
  {header: "Length (m)", accessorKey: "length", size: 90},
  {header: "Width (m)", accessorKey: "width", size: 90},
  {header: "Height (m)", accessorKey: "height", size: 90},
  {header: "volume (m3)", accessorKey: "volume", size: 100},
  {header: "weight (kg)", accessorKey: "weight", size: 100},
  {header: "Note", accessorKey: "note", size: 160, alignStart: true},
  {header: "Who and when added", accessorKey: "addedBy", size: 170},
]);
